import React, { Component } from "react";
import { StripeProvider, Elements } from "react-stripe-elements";
import { connect } from "react-redux";
import { createPaymentIntent } from "../../../store/thunks/create-payment-intent";
import { InjectedPaymentForm } from "../injected-payment-form";
import { setStripePublicKey } from "../../../constants/integrations";

const getURLParam = (variable) => {
  const query = window.location.search.substring(1);
  let vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split("=");
    if (pair[0] === variable) return pair[1];
  }
  return null;
};

class StripePayment extends Component {
  constructor() {
    super();
    this.state = {
      stripe: null,
      intent: null,
    };
  }

  componentDidMount() {
    if (window.Stripe) {
      this.setState({ stripe: window.Stripe(setStripePublicKey()) });
    } else {
      document.querySelector("#stripe-js").addEventListener("load", () => {
        this.setState({ stripe: window.Stripe(setStripePublicKey()) });
      });
    }
    const provider = getURLParam("provider");
    this.props.createIntent(provider);
  }

  render() {
    const { stripe } = this.state;
    const {
      formState,
      pushLocation,
      setValidation,
      submitNewJob,
      intent,
    } = this.props;
    return (
      <StripeProvider stripe={stripe}>
        <Elements>
          <InjectedPaymentForm
            formState={formState}
            submitNewJob={submitNewJob}
            pushLocation={pushLocation}
            setValidation={setValidation}
            intent={intent}
          />
        </Elements>
      </StripeProvider>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    intent: state.intentState.intent,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    createIntent(provider) {
      dispatch(createPaymentIntent(provider));
    },
  };
};

export const StripePaymentContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(StripePayment);
